export const RutinaLeerArchivoInputFile = async (event) => {
    const file = event.target.files[0];
    const base64 = await ConvertirArchivoBase64(file);

    const fileInfo = {
        nombre: file.name,
        tipo: file.type,
        tamano: file.size,
        contenido: base64,
        extension: file.name.split('.').pop().toLowerCase()
    }

    return fileInfo;

}

export const ConvertirArchivoBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file)
        fileReader.onload = () => {
            resolve(fileReader.result);
        }
        fileReader.onerror = (error) => {
            reject(error);
        }
    })
}

export const DescargarArchivoBase64 = async (nombre, tipo, contenido) => {
    
    const base64Response = await fetch(contenido);
    const blobContenido = await base64Response.blob();
    const link = document.createElement('a');
    link.style.display = 'none';
    link.download = 'test' + nombre;
    link.href = (window.URL) ? window.URL.createObjectURL(blobContenido) : window.webkitURL.createObjectURL(blobContenido);
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(link.href);
    document.body.removeChild(link);

}